import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

import {getHealthAvailableTimes} from '../../services/getHealthAvailableTimes';
import {UseGetHealthAvailableTimesQueryProps} from './types';
import {useBookingStore} from '../../store/useBookingStore';
import {useQueryParams} from 'presentation/pages';
import {ShiftTypeEnum} from 'presentation/modules/booking/exam/constants/shiftTypeEnum';
import {EntryPointCodeEnum} from 'presentation/constants/entryPointCodeEnum';
import {TELEMEDICINE_INFO} from '../../constants/telemedicineInfo';
import {HEALTH_AVAILABLE_TIMES_STALE_TIME} from './constants';

export function useGetHealthAvailableTimesQuery({
	isTelemedicine,
	enabled,
}: UseGetHealthAvailableTimesQueryProps) {
	const bookingData = useBookingStore(state => state.bookingData);
	const {
		SEARCH_PARAMS: {shift, autocompleteQuery},
	} = useQueryParams();

	const availableTimesParams = {
		dateAt: bookingData.dateAt,
		unitCode: isTelemedicine ? TELEMEDICINE_INFO.code : bookingData.unitCode,
		shift: shift as ShiftTypeEnum,
		specialtyCode: bookingData.specialtyCode,
		subSpecialtyCode: bookingData.subSpecialtyCode,
		providerId:
			(bookingData?.isFavoriteDoctorsFlow && bookingData?.professionalCode) ||
			autocompleteQuery,
	};

	return useQuery({
		queryKey: [QUERY_KEYS.HEALTH_AVAILABLE_TIMES, availableTimesParams, isTelemedicine],
		queryFn: ({signal}) =>
			getHealthAvailableTimes({
				clinic_code: availableTimesParams.unitCode,
				specialty_code: availableTimesParams.specialtyCode,
				entryPointCode: Number(EntryPointCodeEnum.V2),
				subspecialty_code: availableTimesParams.subSpecialtyCode,
				date: availableTimesParams.dateAt,
				shift_type: availableTimesParams.shift,
				providerCode: availableTimesParams.providerId,
				signal,
			}),
		enabled,
		staleTime: HEALTH_AVAILABLE_TIMES_STALE_TIME,
	});
}
